/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RouteDtoModel, RouteDtoModelType } from "./RouteDtoModel"
import { RouteDtoModelSelector } from "./RouteDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  route: RouteDtoModelType;
}

/**
 * RouteDeletingFailedDtoBase
 * auto generated base class for the model RouteDeletingFailedDtoModel.
 *
 * Route deleting failed event
 */
export const RouteDeletingFailedDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('RouteDeletingFailedDto')
  .props({
    __typename: types.optional(types.literal("RouteDeletingFailedDto"), "RouteDeletingFailedDto"),
    /** Payload of route deleting failed */
    route: types.union(types.undefined, MSTGQLRef(types.late((): any => RouteDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class RouteDeletingFailedDtoModelSelector extends QueryBuilder {
  route(builder: string | RouteDtoModelSelector | ((selector: RouteDtoModelSelector) => RouteDtoModelSelector) | undefined) { return this.__child(`route`, RouteDtoModelSelector, builder) }
}
export function selectFromRouteDeletingFailedDto() {
  return new RouteDeletingFailedDtoModelSelector()
}

export const routeDeletingFailedDtoModelPrimitives = selectFromRouteDeletingFailedDto()
